import React from 'react'
import { App } from './views'
import { routesConfig } from './routesConfig'
import { AppIcon } from './components'
import { displayName, appName } from './appConfig'
import { getCalendarEvents } from './helpers/calendarEvents'

export const appDefinition = {
  displayName,
  name:      appName,
  category:  'processes',
  Component: () => <App appName={appName} />,
  AppIcon,
  routes:    routesConfig(appName, displayName),
  // Opts this app into the global ActivityWidget's cross-app aggregation (see
  // spa/src/hooks/useActivity.js) — any app can do the same by exposing these
  // two fields, no changes needed elsewhere.
  calendarColor:  'var(--color-blue)',
  calendarEvents: getCalendarEvents,
}
